const forgeUiComponent = require('../framework/ui-component');
const timeFormatter = require('../helpers/formatTime');

const ON_AIR_TEXT = 'On Air';

var NotificationsGroup = forgeUiComponent('NotificationsTicker-group', {
  enabled: 'is-enabled'
}, function NotificationsGroupConstructor(el, options) {
  var self = this;
  var trackTitle = el.querySelector('.TrackInfo-title') || document.createElement('div');
  var trackSubtitle = el.querySelector('.TrackInfo-subTitle') || document.createElement('div');
  var sourceTitle = el.querySelector('.SourceInfo-title') || document.createElement('a');
  var sourceCaption = el.querySelector('.SourceInfo-caption') || document.createElement('div');
  var sourceImage = el.querySelector('.SourceInfo-artImage') || document.createElement('div');

// Expose properties
  Object.defineProperty(this, 'artSrc', {
    get: function getArt() { return sourceImage.src; },
    set: function setArt(src) {
      // HACK: FIX: This code doesn't support <picture>/srcset yet, so we're hard-coding to 2x retina as a compromise.
      const ioSrc = [src, '?', 'width=360&height=360&fit=crop'].join('');

      if (sourceImage.src === ioSrc) { return; }

      sourceImage.src = src ? ioSrc : '';
      this.missingImage = !src;
    }
  });

  Object.defineProperty(this, 'title', {
    get: function getTitle() { return trackTitle.textContent; },
    set: function setTitle(title) {
      if (trackTitle.textContent === title) { return; }

      requestAnimationFrame(function () {
        trackTitle.textContent = title || '';
        trackTitle.title = title || '';
      });
    }
  });

  Object.defineProperty(this, 'subTitle', {
    get: function getSubTitle() { return trackSubtitle.textContent; },
    set: function setSubTitle(subTitle) {
      if (trackSubtitle.textContent === subTitle) { return; }

      requestAnimationFrame(function () {
        trackSubtitle.textContent = subTitle || '';
        trackSubtitle.title = subTitle || '';
      });
    }
  });

  Object.defineProperty(this, 'showName', {
    get: function getShowName() { return sourceTitle.textContent; },
    set: function setShowName(showName) {
      if (sourceTitle.textContent === showName) { return; }

      requestAnimationFrame(function () {
        sourceTitle.textContent = showName || '';
        sourceTitle.title = showName || '';
      });
    }
  });

  Object.defineProperty(this, 'showUrl', {
    get: function getShowName() { return sourceTitle.href; },
    set: function setShowName(url) {
      if (sourceTitle.href === url) { return; }
      sourceTitle.href = url || '';
    }
  });

  Object.defineProperty(this, 'showCaption', {
    get: function getShowCaption() { return sourceCaption.textContent; },
    set: function setShowCaption(caption) {
      const newCaption = this.liveStream ? ON_AIR_TEXT : caption || '';

      if (sourceCaption.textContent === newCaption) { return; }

      requestAnimationFrame(function () {
        sourceCaption.textContent = newCaption;
      });
    }
  });

  options.bindRecieveMetadataUpdate(function (metadata) {
    self.updateContent(metadata);
  });
  options.bindRecieveProgressUpdate(function (progress) {
    self.updateProgress(progress);
  });
});

NotificationsGroup.prototype.updateContent = function updateContent(metadata) {
  this.enabled = !!metadata.title;

  if (!metadata.title) { return; }

  this.title = metadata.title;
  this.subTitle = metadata.artist;

  this.showName = metadata.show;
  this.showUrl = metadata.showUrl;

  // HACK: We're duplicating setting the text for ON AIR due to being out of sync
  // updating the real element content. Might need some sort of buffer for that.
  this.showCaption = metadata.isStream ? ON_AIR_TEXT : metadata.duration;

  this.artSrc = metadata.image;
  this.liveStream = metadata.isStream;
};

NotificationsGroup.prototype.updateProgress = function updateProgress(metadata) {
  this.showCaption = (metadata.duration && (metadata.duration !== Infinity)) ?
    [timeFormatter.formatTime(metadata.time), timeFormatter.formatTime(metadata.duration)].join('/') :
    timeFormatter.formatTime(metadata.time);
};

module.exports = NotificationsGroup;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/notificationgroup.js
// module id = 127
// module chunks = 0